export const LOADING_MESSAGES = {
  DEFAULT: "Loading...",
  APPLICATION: "Loading application...",
  PAGE: "Loading...",
  ADMIN_ACCESS: "Verifying access...",
  PROFILE: "Loading profile...",
  BUSINESS_DATA: "Loading business data...",
  ANALYTICS: "Loading analytics...",
  USER_DATA: "Loading user data...",
} as const;

export type LoadingMessageKey = keyof typeof LOADING_MESSAGES;